import { render, staticRenderFns } from "./ProductResume.vue?vue&type=template&id=15e433a0&scoped=true"
import script from "./ProductResume.vue?vue&type=script&lang=js"
export * from "./ProductResume.vue?vue&type=script&lang=js"
import style0 from "./ProductResume.vue?vue&type=style&index=0&id=15e433a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e433a0",
  null
  
)

export default component.exports